import { motion } from "framer-motion";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const details = [
  { icon: Phone, label: "Phone", value: "07770 347944", href: "tel:07770347944", testid: "contact-phone" },
  { icon: Mail, label: "Email", value: "clarkegroundcare@gmail.com", href: "mailto:clarkegroundcare@gmail.com", testid: "contact-email" },
  { icon: MapPin, label: "Based in", value: "Washington, NE England — serving Sunderland, Durham, Gateshead & surrounding areas", testid: "contact-area" },
  { icon: Clock, label: "Business hours", value: "Monday to Sunday", testid: "contact-hours" },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export const Contact = () => {
  return (
    <section id="contact" className="relative bg-brand-surface py-24 md:py-36">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="flex items-center gap-3 mb-6"
        >
          <span className="h-px w-12 bg-brand-orange" />
          <span className="text-xs md:text-sm tracking-[0.25em] uppercase font-heading text-brand-orange">
            Get in touch
          </span>
        </motion.div>

        <motion.h2
          variants={reveal}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          className="font-heading font-medium tracking-tight text-white text-4xl md:text-6xl max-w-2xl leading-[1.05] mb-16"
        >
          Speak to the team directly.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {details.map((d, i) => (
            <motion.a
              key={d.label}
              data-testid={d.testid}
              href={d.href || undefined}
              variants={reveal}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: i * 0.06 }}
              className={`group bg-brand-ink p-8 md:p-12 flex items-start gap-5 ${d.href ? "cursor-pointer" : "cursor-default"}`}
            >
              <span className="shrink-0 w-12 h-12 flex items-center justify-center border border-white/15 group-hover:border-brand-orange group-hover:bg-brand-orange transition-colors">
                <d.icon size={20} className="text-brand-orange group-hover:text-white transition-colors" />
              </span>
              <div>
                <p className="text-xs tracking-[0.2em] uppercase text-white/40 mb-2">{d.label}</p>
                <p className="font-heading text-white text-lg md:text-2xl break-words group-hover:text-brand-orange transition-colors">
                  {d.value}
                </p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
